import React from "react";

const QuotationWorklistHeader = () => (
  <div className="quote-worklist-header">
    <div>Project</div>
    <div>Project Ref</div>
    <div>Distributor</div>
    <div>Country</div>
    <div className="text-right">Quoted</div>
    <div className="text-right">Order</div>
    <div></div>
  </div>
);

export default React.memo(QuotationWorklistHeader);
